<template>
    <svg :class="className" width="9" height="5" viewBox="0 0 9 5">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.70472 0.31687C3.9177 0.112299 4.19891 0 4.50037
            0C4.80109 0 5.0838 0.112299 5.29528 0.31687L8.78009 3.76596C9.0733 4.0485 9.0733 4.50556 8.78009
            4.7881C8.48763 5.07063 8.01294 5.07063 7.71972 4.7881L4.50037 1.59436L1.28028 4.7881C0.987064
            5.07063 0.513123 5.07063 0.21991 4.7881C-0.0733033 4.50556 -0.0733033 4.0485 0.21991 3.76596L3.70472
            0.31687Z">
        </path>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>
